// Libs
import React, { Component } from 'react'
import { Polyline, Marker, LayerGroup } from 'react-leaflet'
import _forEach from 'lodash/forEach'
import _map from 'lodash/map'

// Turf
import centerField from '@turf/center'
import transformTranslate from '@turf/transform-translate'
import distance from '@turf/distance'
import rhumbBearing from '@turf/rhumb-bearing'
import 'leaflet-path-drag'
import L from 'leaflet'

// Image
import gridCenterIcon from '../icons/grid-center.url.svg'

// Style
const styles = {
  grid: {
    color: '#FF0000',
    strokeWidth: 0.5,
  },
}

// Local
const gridCenter = L.icon({
  iconUrl: gridCenterIcon,
  iconSize: [7, 7],
})

// Props
type Props = {
  operation: Object,
  gridData: Object,
  selectedFeatureIndices: Array<number>,
  onChangeGridOffset: Function,
}

// Exports
class Grid extends Component {
  props: Props

  constructor (props) {
    super(props)

    this.updatePosition = (center, squareGrid) => (e) => this.onMove(e, center, squareGrid)
  }

  onMove (e, center, fieldGrid) {
    const [ oldLat, oldLng ] = center
    const { lat: newLat, lng: newLng } = e.latlng

    const oldLatLng = [oldLng, oldLat]
    const newLatLng = [newLng, newLat]

    let offsetDistance = distance(oldLatLng, newLatLng)
    let offsetBearing = rhumbBearing(oldLatLng, newLatLng)

    fieldGrid = transformTranslate(fieldGrid, offsetDistance, offsetBearing, {
      units: 'kilometers',
      zTranslation: 0,
    })

    const fieldCenter = centerField(fieldGrid)

    const [ longitude, latitude ] = fieldCenter.geometry.coordinates

    let features = {}

    _forEach(this.props.selectedFeatureIndices, (featureIndex) => {
      features[featureIndex] = {
        ...this.props.operation.model.gridData.grid[featureIndex],
        offset: { longitude, latitude },
      }
    })

    this.props.onChangeGridOffset({
      ...this.props.operation,
      model: {
        gridData: {
          ...this.props.operation.model.gridData,
          grid: {
            ...this.props.operation.model.gridData.grid,
            ...features,
            transformations: {
              ...this.props.operation.model.gridData.grid.transformations,
              offset: { longitude, latitude },
            },
          },
        },
      },
    })
  }

  renderGrid ({ shapes }): React.Element<any> {
    return _map(shapes, ({positions, center, strokeWidth, strokeColor}) =>
      <Polyline
        key={`marker_${center[0]}_${center[1]}`}
        positions={positions}
        color={styles.grid.color}
        weight={styles.grid.strokeWidth} />
    )
  }

  renderPoints ({ gridPoints, squareGrid, isLocked }): React.Element<any> {
    return _map(gridPoints, (gridPoint, i) => {
      if (gridPoint) {
        return (
          <Marker
            key={`grid-point-${i}`}
            position={gridPoint}
            draggable={!isLocked}
            icon={gridCenter}
            onDrag={this.updatePosition(gridPoint, squareGrid)}
          />
        )
      }
    })
  }

  renderGrids (): React.Element<any> {
    return _map(this.props.gridData, (grid, i) => <LayerGroup key={`layer-group-${i}`}>
      {this.renderGrid(grid)}
      {this.renderPoints(grid)}
    </LayerGroup>)
  }

  render (): React.Element<any> {
    return (
      <div data-test='hefty-grid'>
        {this.renderGrids()}
      </div>
    )
  }
}

Grid.contextTypes = {
  map: require('prop-types').any,
}

export default Grid
